<template>
  <v-expansion-panels style="display: contents !important">
    <v-expansion-panel id="processing-list-panel" class="mb-3">
      <v-expansion-panel-header
        :expand-icon="isToOpenExpansionPanel() ? 'keyboard_arrow_down' : ' '"
      >
        <v-layout justify-space-between align-center>
          <div>{{ processing.pr_description }}</div>

          <processing-button
            :state="processing.state ? processing.state : 'default'"
            @run-processing="runProcessing(processIndex)"
            @change-to-default="changeToDefault"
            :play-is-disable="buttonIsDisable"
          />
        </v-layout>
      </v-expansion-panel-header>
      <v-expansion-panel-content
        v-if="isToOpenExpansionPanel()"
        id="processing-list-panel-content"
      >
        <v-card>
          <v-card-text class="grey lighten-3 pa-3">
            <processing-warning
              v-if="processing.state === 'warning'"
              :number-of-objects="processing.numberOfObjects"
              @change-to-default="changeToDefault(processIndex)"
              @finish-processing="finishProcessing(processIndex)"
            />

            <template v-else>
              <div
                v-for="(settings, index) in processing.pr_params"
                :key="index"
                v-if="settings.type !== 'internal'"
              >
                <label v-if="settings.label !== ''" class="form-label-div">
                  {{ settings.label + ":" }}
                </label>
                <input
                  min="0"
                  v-if="
                    settings.type === 'integer' && settings.name !== 'start'
                  "
                  :type="getType(settings.type)"
                  :value="dataToSend[settings.name]"
                  @input="updateValue(settings.name, $event.target.value)"
                  @keypress="checkInteger"
                  :step="autoNumberFieldStep(settings.type)"
                  class="input-container"
                />
                <treeselect
                  v-if="
                    settings.type === 'integer' && settings.name === 'start'
                  "
                  :load-options="getTechnicalSitesWithTechnicalLocals"
                  :options="technicalPointOptions"
                  :auto-load-root-options="false"
                  :value="dataToSend[settings.name]"
                  @input="updateValue(settings.name, $event)"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  :placeholder="$tc('TechnicalLocal', 1)"
                  disableFuzzyMatching
                />
                <treeselect
                  v-if="settings.type === 'multiselect'"
                  :multiple="true"
                  :options="layerOptions"
                  :auto-load-root-options="false"
                  :value="dataToSend[settings.name]"
                  @input="updateValue(settings.name, $event)"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  :placeholder="$tc('Layer', 2)"
                  disableFuzzyMatching
                />
                <treeselect
                  v-if="
                    settings.type === 'select' &&
                    settings.name === 'selectedServiceOptions'
                  "
                  :options="serviceOptions"
                  :auto-load-root-options="false"
                  :value="dataToSend[settings.name]"
                  @input="updateValue(settings.name, $event)"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  :placeholder="$tc('Service', 2)"
                  disableFuzzyMatching
                />
                <treeselect
                  v-if="
                    settings.type === 'select' &&
                    settings.name === 'selectedTpaOptions'
                  "
                  :options="tpaOptions"
                  :auto-load-root-options="false"
                  :value="dataToSend[settings.name]"
                  @input="updateValue(settings.name, $event)"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  :placeholder="$tc('TPA', 2)"
                  disableFuzzyMatching
                />
              </div>
            </template>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import ProcessingButton from "@/components/Home/Content/ObjectWindow/Processing/ProcessingButton";
import ProcessingWarning from "@/components/Home/Content/ObjectWindow/Processing/ProcessingWarning";
import { workspaceTechSitesLocalsMixin } from "@/mixins/workspaceTechSitesLocalsMixin";

export default {
  name: "ProcessingExpansionPanel",

  components: { ProcessingWarning, ProcessingButton },

  mixins: [workspaceTechSitesLocalsMixin],

  props: {
    processing: {
      type: Object,
      required: true,
    },

    processIndex: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      dataToSend: {},
      buttonIsDisable: false,
      technicalPointOptions: null,
      layerOptions: [],
      serviceOptions: [],
      tpaOptions: [],
      keyvalues: [],
    };
  },

  computed: {
    currentWorkspaceUUID() {
      return this.$store.getters.workspace.uuid;
    },
  },

  mounted() {
    this.buttonIsDisable = this.isDisable();
    this.getLayers();
    this.getService();
    this.getTPA();
  },

  watch: {
    currentWorkspaceUUID() {
      this.changeToDefault();

      this.dataToSend = {};
    },
  },

  methods: {
    /**
     * Function to load technicalsites options in treeselect.
     * @returns - array containing label and id of technical locals.
     */
    async getTechnicalSitesWithTechnicalLocals() {
      let options;
      try {
        options = await this.GET_WORKSPACE_TECHNICAL_SITES_WITH_LOCALS(
          this.currentWorkspaceUUID
        );
        this.technicalPointOptions =
          this.getTechnicalSitesWithLocalsOptions(options);
      } catch (e) {
        console.log(e);
      }
    },

    getLayers() {
      const layersParam = this.param("layers");

      if (layersParam) {
        for (const [key, value] of Object.entries(layersParam.options)) {
          this.layerOptions.push({ id: key, label: value });
        }
      }
    },

    getService() {
      const servicesParam = this.param("Service");

      if (servicesParam) {
        for (const [key, value] of Object.entries(servicesParam.options)) {
          this.serviceOptions.push({ id: key, label: value });
        }
      }
    },

    getTPA() {
      const tpasParam = this.param("TPA");

      if (tpasParam) {
        for (const [key, value] of Object.entries(tpasParam.options)) {
          this.tpaOptions.push({ id: key, label: value });
        }
      }
    },

    param(obj) {
      let param = this.processing.pr_params.filter((object) => {
        return object.label === obj;
      })[0];

      return param;
    },
    /**
     * Creates a Technical local object that the treeselect component can read as an option.
     * Overwrites mixins function with different value (tl_id).
     * @param {object} tl - Original Technical local object
     * @return {object} the adapted object - in this instance the tl_id is needed.
     */
    createTechnicalLocalOption(tl) {
      let newTl = {};
      newTl.id = tl.tl_id;
      newTl.label = tl.tl_technical_site_logical_type + ": ";
      if (tl.tl_label) {
        newTl.label += tl.tl_label;
      } else {
        newTl.label += tl.tl_id;
      }
      return newTl;
    },

    /**
     * Emits an event to run processing
     */
    runProcessing(processingItemIndex) {
      this.$emit("run-processing", {
        index: processingItemIndex,
        data: this.dataToSend,
      });
    },

    /**
     * Emits an event to end processing
     */
    finishProcessing(processingItemIndex) {
      this.dataToSend = this.processing.dataToSend;
      this.dataToSend["apply"] = true;
      this.$emit("run-processing", {
        index: processingItemIndex,
        data: this.dataToSend,
      });

      this.dataToSend = {};
    },

    /**
     * Updates the value of a specific field.
     * @param field
     * @param newValue
     */
    updateValue(field, newValue) {
      this.dataToSend[field] = newValue;

      this.buttonIsDisable = !(this.processing.pr_params.every(param => {
        if (param.type === 'internal') return true;
        let inputContents = typeof this.dataToSend[param.name] !== 'undefined'? this.dataToSend[param.name]: '';

        if (Array.isArray(inputContents)) {
          inputContents = inputContents.join(',');
        }
        return typeof inputContents === 'string' && inputContents !== '' || (typeof inputContents !== 'string' && inputContents >= 0);
      }));
    },

    /**
     * Changes the processing state to default
     */
    changeToDefault() {
      this.$emit("change-to-default", this.processIndex);
    },

    /**
     * defines whether the panel expands or not
     * @returns {boolean}
     */
    isToOpenExpansionPanel() {
      return (
        (this.isDisable() &&
          (this.processing.state === "default" || !this.processing.state)) ||
        this.processing.state === "warning"
      );
    },

    /**
     * Returns true if the list has fields of type other than internal
     *
     * @return {boolean}
     */
    isDisable() {
      let list = [];
      if (this.processing.pr_params) {
        this.processing.pr_params.forEach((setting) => {
          if (setting.type !== "internal") {
            list.push(setting);
          }
        });
      }
      return list.length !== 0;
    },

    /**
     * defines the type of field that will be
     * @param type - text, integer or float
     * @returns {string} - type
     */
    getType(type) {
      if (type === "text") {
        return "text";
      } else if (type === "integer" || type === "float") {
        return "number";
      }
    },

    autoNumberFieldStep(inputType) {
      if (inputType === "float") {
        return 0.01;
      }
      return 1;
    },
    checkInteger(e) {
      const regex = /^[0-9]*$/;
      //if input is not a number validates to true
      if (!regex.test(e.key)) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
.input-container {
  border: 1px solid var(--secondary-lighter);
  background-color: #ffffff;
  width: 100%;
}

.input-container:focus {
  border-bottom: 1px solid var(--primary-highlight);
}

.form-label-div {
  font-size: 12px !important;
  color: rgba(0, 0, 0, 0.87);
}
</style>

<style>
#processing-list-panel .v-expansion-panel-header {
  padding: 5px 10px;
  min-height: unset;
  font-size: 12px;
}

#processing-list-panel .v-expansion-panel-header .v-icon.v-icon {
  font-size: 18px;
}

#processing-list-panel-content .v-expansion-panel-content__wrap {
  padding: 0 !important;
  text-align: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/Processing/ProcessingExpansionPanel.vue